import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slider2 = ({ settings, slider1, sliderdata1 }) => {
  return (
    <>
      <Slider className="technologies_content text-white" {...settings}>
        {sliderdata1 &&
          sliderdata1.length > 0 &&
          sliderdata1.map((key, index) => (
            <div key={index} className="slider_slid">
              <div className="row justify-content-around">
                {key.sub_technology.map((cell, cellIndex) => (
                  <div
                    key={cellIndex}
                    className="col-md-auto col-sm-6 col-6 mb-3"
                  >
                    <div>
                      <img src={cell.icon.url} className="img-fluid" />
                    </div>
                    <h3>
                      <span>{cell.list}</span>
                    </h3>
                  </div>
                ))}
              </div>
            </div>
          ))}
        {/* <div className="slider_slid">
                    <div className="row justify-content-around">
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>HTML5</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="48" height="42.706"
                                    viewBox="0 0 48 42.706">
                                    <g id="ic-technology-react-native">
                                        <path id="Combined-Shape-Copy-22"
                                            d="M25.218,4.2C29.354.605,33.449-.9,35.953.543c2.611,1.506,3.376,6.08,2.206,11.757q-.107.519-.238,1.054.8.229,1.545.487C44.65,15.626,48,18.422,48,21.312c0,3.014-3.58,5.962-9.083,7.785q-.436.144-.892.279.163.654.287,1.282c1.086,5.487.25,10-2.325,11.488-2.493,1.443-6.522.025-10.6-3.485q-.646-.556-1.3-1.183-.5.485-1,.922c-4.211,3.681-8.537,5.209-11.113,3.723C9.479,40.686,8.695,36.487,9.7,31.2q.159-.836.376-1.712-.67-.193-1.3-.407C3.484,27.271,0,24.287,0,21.312c0-2.88,3.245-5.657,8.327-7.429q.852-.3,1.776-.559-.2-.808-.354-1.59C8.7,6.354,9.438,2.054,11.939.606c2.609-1.51,6.953.111,11.288,3.96q.4.352.795.733.43-.412.858-.8h0ZM36.042,29.9l-.217.05a48.251,48.251,0,0,1-6.284.953,48.138,48.138,0,0,1-4.022,5.108q.606.584,1.206,1.1c3.489,3,6.724,4.14,8.236,3.265,1.594-.923,2.275-4.594,1.341-9.315Q36.189,30.489,36.042,29.9Zm-23.977.093-.033.129q-.129.53-.235,1.044h0l-.083.419c-.859,4.522-.229,7.893,1.285,8.766,1.6.92,5.117-.323,8.74-3.49q.455-.4.914-.841a50.146,50.146,0,0,1-4.119-5.091A48.354,48.354,0,0,1,12.064,29.989ZM26.9,31.074l-.225.01q-1.319.054-2.673.054-1.429,0-2.809-.054c.947,1.247,1.917,2.408,2.889,3.457A43.865,43.865,0,0,0,26.9,31.074ZM24,13.623c-1.479,0-2.943.056-4.37.164-.807,1.18-1.587,2.42-2.328,3.706h0l-.278.486c-.633,1.123-1.223,2.255-1.764,3.383.621,1.288,1.306,2.583,2.049,3.868s1.532,2.534,2.346,3.722c1.4.091,2.852.136,4.346.136s2.972-.052,4.4-.154c.781-1.172,1.551-2.415,2.3-3.715s1.44-2.6,2.063-3.886c-.625-1.263-1.317-2.551-2.07-3.85s-1.519-2.521-2.312-3.693C26.953,13.679,25.486,13.623,24,13.623Zm-9.828,10.15-.062.147c-.583,1.4-1.085,2.769-1.494,4.091a43.691,43.691,0,0,0,4.424.711q-.776-1.2-1.507-2.465Q14.818,25.02,14.172,23.773Zm19.7-.074-.1.2q-.612,1.17-1.289,2.343Q31.749,27.5,31,28.686a43.71,43.71,0,0,0,4.479-.764A43.549,43.549,0,0,0,33.868,23.7ZM10.655,15.3l-.214.061Q9.7,15.578,9,15.82c-4.346,1.515-6.952,3.745-6.952,5.492,0,1.842,2.836,4.271,7.39,5.827q.571.2,1.184.371a50.033,50.033,0,0,1,2.369-6.149A49.145,49.145,0,0,1,10.655,15.3Zm26.717.03-.023.073a48.185,48.185,0,0,1-2.314,5.919,48.094,48.094,0,0,1,2.43,6.081l.346-.1h0l.46-.148c4.751-1.574,7.677-3.983,7.677-5.839,0-1.742-2.709-4-7.151-5.532Q38.109,15.543,37.372,15.33ZM24,17.026a4.286,4.286,0,1,1-4.286,4.286A4.286,4.286,0,0,1,24,17.026Zm7.008-2.973.073.115q.708,1.114,1.386,2.286.728,1.257,1.382,2.5a44.033,44.033,0,0,0,1.536-4.134C34.007,14.5,32.539,14.247,31.008,14.053Zm-14.01,0-.507.066c-1.339.181-2.628.409-3.844.681.416,1.344.928,2.737,1.525,4.153q.642-1.245,1.354-2.481h0l.328-.568h.005l.251-.42Q16.545,14.754,17,14.049ZM34.83,2.267c-1.551-.765-4.8.466-8.266,3.484q-.55.479-1.1,1.011a48.276,48.276,0,0,1,4.057,5.064,49.181,49.181,0,0,1,6.419,1.014q.117-.484.214-.954c1.01-4.9.385-8.64-1.222-9.567h0ZM21.637,5.9c-3.658-3.175-7.1-4.429-8.67-3.518-1.508.873-2.107,4.35-1.2,8.96q.142.724.33,1.479a50.082,50.082,0,0,1,6.406-1,49.063,49.063,0,0,1,4.09-5.062q-.362-.343-.721-.663h0ZM24.024,8.23l-.153.164c-.909.992-1.813,2.08-2.7,3.244q1.4-.065,2.826-.066t2.847.067A43.746,43.746,0,0,0,24.024,8.23Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>React Js</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="45" height="48"
                                    viewBox="0 0 45 48">
                                    <g id="angular-js">
                                        <path id="Shape-Copy-11"
                                            d="M18.285,24H27.1l-4.684-9.862ZM22.428,0,0,7.948,3.544,37.536,22.452,48,41.457,37.395,45,7.807ZM16.461,28.192l-2.75,6.927-5.14.021,13.856-30.9L22.4,4.182h-.024V4.132l.024.051h.053l.047-.1v.1h-.047l-.026.058L36.881,35.269l-4.948-.109-3.044-7.081-6.5.031Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Angular</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="49.192" height="49"
                                    viewBox="0 0 49.192 49">
                                    <g id="_04" data-name="04" transform="translate(0 -1)">
                                        <path id="Path_1086" data-name="Path 1086"
                                            d="M44.869,1H4.324A4.328,4.328,0,0,0,0,5.324V45.676A4.328,4.328,0,0,0,4.324,50H44.869a4.328,4.328,0,0,0,4.324-4.324V5.324A4.328,4.328,0,0,0,44.869,1ZM4.324,3.882H44.869A1.443,1.443,0,0,1,46.31,5.324v7.206H2.882V5.324A1.443,1.443,0,0,1,4.324,3.882ZM44.869,47.118H4.324a1.443,1.443,0,0,1-1.441-1.441V15.412H46.31V45.676A1.443,1.443,0,0,1,44.869,47.118Z"
                                            fill="#a2ba5f" />
                                        <path id="Path_1087" data-name="Path 1087"
                                            d="M206.652,196.113a1.441,1.441,0,0,0-1.892.757l-8.647,20.176a1.441,1.441,0,1,0,2.649,1.135l8.647-20.176A1.441,1.441,0,0,0,206.652,196.113Z"
                                            transform="translate(-177.165 -176.262)" fill="#a2ba5f" />
                                        <path id="Path_1088" data-name="Path 1088"
                                            d="M85.776,241.54a1.441,1.441,0,0,0-2.026-.225l-7.206,5.765a1.442,1.442,0,0,0,0,2.251L83.75,255.1a1.441,1.441,0,1,0,1.8-2.251l-5.8-4.639,5.8-4.639A1.441,1.441,0,0,0,85.776,241.54Z"
                                            transform="translate(-68.702 -216.941)" fill="#a2ba5f" />
                                        <path id="Path_1089" data-name="Path 1089"
                                            d="M340.547,247.079l-7.206-5.765a1.441,1.441,0,1,0-1.8,2.251l5.8,4.639-5.8,4.639a1.441,1.441,0,1,0,1.8,2.251l7.206-5.765A1.442,1.442,0,0,0,340.547,247.079Z"
                                            transform="translate(-299.197 -216.94)" fill="#a2ba5f" />
                                        <circle id="Ellipse_60" data-name="Ellipse 60" cx="1.5" cy="1.5" r="1.5"
                                            transform="translate(6 7)" fill="#a2ba5f" />
                                        <circle id="Ellipse_61" data-name="Ellipse 61" cx="1.5" cy="1.5" r="1.5"
                                            transform="translate(12 7)" fill="#a2ba5f" />
                                        <circle id="Ellipse_62" data-name="Ellipse 62" cx="1.5" cy="1.5" r="1.5"
                                            transform="translate(17 7)" fill="#a2ba5f" />
                                        <path id="Path_1090" data-name="Path 1090"
                                            d="M332.441,63.882h8.647a1.441,1.441,0,1,0,0-2.882h-8.647a1.441,1.441,0,0,0,0,2.882Z"
                                            transform="translate(-299.198 -54.235)" fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Ajax</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="41.071" height="46"
                                    viewBox="0 0 41.071 46">
                                    <path id="_05" data-name="05"
                                        d="M5.465,2a1,1,0,0,0-1,1.09l3.52,39.426a1,1,0,0,0,.721.873l16.01,4.572a1,1,0,0,0,.549,0l16.025-4.572a1,1,0,0,0,.721-.873L45.531,3.09a1,1,0,0,0-1-1.09ZM6.559,4H43.441L40.084,41.654l-15.09,4.307L9.92,41.654ZM19,10a1,1,0,0,0-1,1V29.629l-5.732-1.588A1,1,0,0,0,11,29v4.945a1,1,0,0,0,.732.963l11,3.051A1,1,0,0,0,24,37V11a1,1,0,0,0-1-1Zm8,0a1,1,0,0,0-1,1V28a1,1,0,0,0,1.17.986L32.918,28,32.8,29.768l-6.064,1.668A1,1,0,0,0,26,32.4V37a1,1,0,0,0,1.266.965l10-2.75A1,1,0,0,0,38,34.336l1.055-12.25a1,1,0,0,0-1.137-1.076L32,21.848V16h6.654a1,1,0,0,0,1-.914l.346-4A1,1,0,0,0,39,10Zm-7,2h2V35.686l-9-2.5V30.318l5.732,1.59A1,1,0,0,0,20,30.945Zm8,0h9.91l-.174,2H31a1,1,0,0,0-1,1v8a1,1,0,0,0,1.141.99l5.811-.824-.889,10.3L28,35.688V33.162l6.016-1.654a1,1,0,0,0,.732-.9l.25-3.75a1,1,0,0,0-1.168-1.053l-5.83,1Z"
                                        transform="translate(-4.465 -2)" fill="#a2ba5f" />
                                </svg>
                            </div>
                            <h3>
                                <span>Javascript</span>
                            </h3>
                        </div>
                    </div>
                </div>

                <div className="slider_slid">
                    <div className="row justify-content-around">
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Wordpress</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>React Js</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>React Js</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>React Js</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>React Js</span>
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="slider_slid">
                    <div className="row justify-content-around">
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Woocommers</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Angular</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Angular</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Angular</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Angular</span>
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="slider_slid">
                    <div className="row justify-content-around">
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>SQL</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Ajax</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Ajax</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Ajax</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Ajax</span>
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="slider_slid">
                    <div className="row justify-content-around">
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>PHP</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Javascript</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Javascript</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Javascript</span>
                            </h3>
                        </div>
                        <div className="col-md-auto col-sm-6 col-6 mb-3">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" id="Page-1" width="42" height="48"
                                    viewBox="0 0 42 48">
                                    <g id="html5">
                                        <path id="Shape-Copy-9"
                                            d="M33.707,14.07l.477-5.25H7.815l1.4,16.02H27.473l-.656,6.84L20.94,33.27l-5.847-1.59-.388-4.2H9.486l.656,8.34,10.8,3h.119v-.03l10.709-2.97L33.26,19.5H14.05L13.6,14.07ZM0,0H42L38.182,43.14,20.94,48,3.818,43.14Z"
                                            fill="#a2ba5f" />
                                    </g>
                                </svg>
                            </div>
                            <h3>
                                <span>Javascript</span>
                            </h3>
                        </div>
                    </div>
                </div> */}
      </Slider>
    </>
  );
};

export default Slider2;
